// @tenorlab/nuxt-dashboard-pro
// file: app/models/navigation/strategies.ts
import { menuItemsCatalog } from './catalog'
import { AppMenuTypeEnum } from '../app'
import type { INavigationItem } from './interfaces'

const _fullMenu: INavigationItem[] = [
  //menuItemsCatalog.homeMenu,
  // menuItemsCatalog.dashboardReadonlyMenu,
  // menuItemsCatalog.aboutMenu,
]

export const navigationItemsStrategy = new Map<AppMenuTypeEnum, INavigationItem[]>([
  [AppMenuTypeEnum.full, _fullMenu],
  //[AppMenuTypeEnum.evaluation, _evaluationMenu],
])

export const getSecondaryNavigationItems = (): INavigationItem[] => {
  let results: INavigationItem[] = [menuItemsCatalog.aboutMenu]

  return results
}
